import React, { useEffect, useRef } from "react";
import Typewriter from "typewriter-effect/dist/core";
import Aos from "aos";
import "aos/dist/aos.css";
import "./header.scss";

export const Header = () => {
  const headingRef = useRef(null);

  useEffect(() => {
    Aos.init({ duration: 2000 });

    new Typewriter(headingRef.current, {
      loop: false,
      cursor: "|",
    })
      .pauseFor(300)
      .typeString('<span style="color: #986DFF;">Hey there! I’m Sofia.</span>')
      .start();
  }, []);

  return (
    <section id="home-page">
      <div className="parent landing-par">
        <div className="container landing-page">
          <div className="header-page">
            <div className="row header-two" data-aos="fade-up">
              <h2 ref={headingRef} aria-label="Typewriter subtitle"></h2>
            </div>

            <div className="row header-title" data-aos="fade-up">
              {/* <h1>Where uncertainty <br /> meets math.</h1> */}
              <h1>Building Data Science<br /> and AI-powered Solutions</h1>
            </div>

            <div className="row landing-description" data-aos="fade-up">
              <p>
                I believe data tells stories, and I love uncovering them. Combining{" "}
                <a className="work-link" href="https://www.thescore.com/">analytical reasoning</a> and{" "}
                <a className="work-link" href="https://fibra.com/">creative problem-solving</a>, I craft Data Science solutions that reveal patterns, test hypotheses, and drive decisions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Header;
